import { render, staticRenderFns } from "./HeTong.vue?vue&type=template&id=80e335be&scoped=true&"
import script from "./HeTong.vue?vue&type=script&lang=js&"
export * from "./HeTong.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e335be",
  null
  
)

export default component.exports